






























import { Component, Mixins } from "vue-property-decorator";
import { Getter } from "vuex-class";
import Actions from "wallet/components/snapshot/Actions.vue";
import Snapshots from "wallet/components/snapshot/Snapshots.vue";
import mixins from "@/mixins";

@Component({
  components: {
    Actions,
    Snapshots
  }
})
class SnapshotsPage extends Mixins(mixins.scrollAppbarPage) {
  @Getter("wallet/mixin/getAssetById") getAssetById;

  get themeColor(): any {
    return "#0596FF";
  }

  get title() {
    return this.$t("common.snapshots") as string;
  }

  get inited() {
    return this.asset;
  }

  get assetId() {
    return this.$route.params.id as string;
  }

  get asset() {
    return this.getAssetById(this.assetId);
  }

  get balance() {
    if (!this.asset) {
      return "-";
    }
    return this.asset.balance;
  }

  get totalLegal() {
    if (!this.asset) {
      return "-";
    }
    const totalUSDT = Number(this.asset.balance) * Number(this.asset.price_usd);
    const totalLegal = this.$common.utils.currency.fiat(this, {
      value: totalUSDT,
      from: "USD"
    });
    return `≈${totalLegal}`;
  }

  handleRefresh() {
    const snapshot = this.$refs.snapshot as any;
    if (snapshot) {
      snapshot.refresh();
    }
  }

  handleBack() {
    this.$router.back();
  }
}
export default SnapshotsPage;
